// import hooks
import { useDocument } from "../../hooks/useDocument";
import { useFirestore } from "../../hooks/useFirestore";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useIsAdmin } from "../../hooks/useIsAdmin";

// import pacchetti
import { useParams, useNavigate } from "react-router-dom";
import format from "date-fns/format";
import { it } from "date-fns/locale";
import { downloadDettaglioSpesaPdf } from "../../stampe/generatori/dettaglioSpesaPdf";
import React, { useState, useEffect } from "react";

// import componenti

// import styles
import "./DettaglioSpesa.css";

// import componenti
// import ProjectSummary from "./ProjectSummary";
// import ProjectComments from "./ProjectComments";

export default function DettaglioSpesa() {
  const navigazione = useNavigate();
  const { user } = useAuthContext();
  const admin = useIsAdmin(user);
  const { id } = useParams();
  const { document: spesa, error } = useDocument("spese", id);
  const { deleteDocument, updateDocument } = useFirestore("spese");

  // Stati per la modifica
  const [isEditing, setIsEditing] = useState(false);
  const [isFattura, setIsFattura] = useState(false);
  const [protocollo, setProtocollo] = useState("");
  const [dettagliModificati, setDettagliModificati] = useState("");
  const [nomeModificato, setNomeModificato] = useState("");

  const handleDelete = () => {
    deleteDocument(spesa.id);
    navigazione("/spese");
  };

  const handleEdit = () => {
    setIsEditing(true);
    setIsFattura(spesa.isFattura || false);
    setProtocollo(spesa.protocollo || "");
    setDettagliModificati(spesa.dettagli || "");
    setNomeModificato(spesa.nome || "");
  };

  // Inizializza i valori quando il documento è caricato
  // Utilizziamo useEffect per evitare l'infinite loop
  useEffect(() => {
    if (spesa) {
      setIsFattura(spesa.isFattura || false);
      setProtocollo(spesa.protocollo || "");
      setDettagliModificati(spesa.dettagli || "");
      setNomeModificato(spesa.nome || "");
    }
  }, [spesa]);

  const handleSave = async () => {
    const updates = {
      isFattura,
      dettagli: dettagliModificati,
      nome: nomeModificato,
    };

    if (isFattura) {
      updates.protocollo = protocollo;
    }

    await updateDocument(spesa.id, updates);
    setIsEditing(false);
  };

  if (error) {
    return <div className="error">{error}</div>;
  }
  if (!spesa) {
    return <div className="loading">Caricamento in corso</div>;
  }

  return (
    <div className="spesa-box">
      <div className="spesa-contenuto">
        <div className="spesa-dettagli">
          {isEditing ? (
            <h2>
              <input
                type="text"
                value={nomeModificato}
                onChange={(e) => setNomeModificato(e.target.value)}
                className="edit-input"
                style={{ fontSize: "1.5em", fontWeight: "bold", width: "100%" }}
              />
            </h2>
          ) : (
            <h2>{spesa.nome}</h2>
          )}
          <div className="corpo-dettagli">
            {isEditing ? (
              <>
                <p>
                  <span>
                    <b>Commento: </b>
                  </span>
                  <textarea
                    value={dettagliModificati}
                    onChange={(e) => setDettagliModificati(e.target.value)}
                    className="edit-textarea"
                  />
                </p>
                <p>
                  <b>È una fattura: </b>
                  <input
                    type="checkbox"
                    checked={isFattura}
                    onChange={(e) => setIsFattura(e.target.checked)}
                  />
                </p>
                {isFattura && (
                  <p>
                    <b>Protocollo: </b>
                    <input
                      type="text"
                      value={protocollo}
                      onChange={(e) => setProtocollo(e.target.value)}
                      className="edit-input"
                    />
                  </p>
                )}
                <p>
                  <b>Importo: </b>
                  {spesa.importo} €
                </p>
                <p>
                  <b>Settore: </b>
                  {spesa.settore.toUpperCase()}
                </p>
                <p>
                  <b>Pagamento: </b>
                  {spesa.pagamento}
                </p>
              </>
            ) : (
              <>
                <p>
                  <span>
                    <b>Commento: </b>
                  </span>
                  {spesa.dettagli}
                </p>
                {spesa.isFattura && (
                  <>
                    <p>
                      <b>È una fattura: </b>
                      Sì
                    </p>
                    <p>
                      <b>Protocollo: </b>
                      {spesa.protocollo}
                    </p>
                  </>
                )}
                <p>
                  <b>Importo: </b>
                  {spesa.importo} €
                </p>
                <p>
                  <b>Cantiere: </b>
                  {spesa.cantiere && typeof spesa.cantiere === 'object' ? spesa.cantiere.nome : spesa.cantiere}
                </p>
                <p>
                  <b>Settore: </b>
                  {spesa.settore.toUpperCase()}
                </p>
                <p>
                  <b>Pagamento: </b>
                  {spesa.pagamento}
                </p>
              </>
            )}
          </div>
        </div>

        <br />
        {(user.uid === spesa.autore.id || admin) && (
          <>
            {!isEditing ? (
              <div className="button-group">
                <button className="btn" onClick={handleDelete}>
                  Elimina Spesa
                </button>
                {admin && (
                  <button className="btn" onClick={handleEdit}>
                    Modifica Spesa
                  </button>
                )}
                <button
                  className="btn"
                  onClick={() => {
                    try {
                      const labelDate = format(spesa.data.toDate(), "dMMMy", { locale: it });
                      const safeAutore = (spesa.autore.displayName || "Utente").replace(/[^a-zA-Z0-9_-]/g, "_").substring(0, 50);
                      const safeSettore = (spesa.settore || "Settore").replace(/[^a-zA-Z0-9_-]/g, "_").substring(0, 30);
                      const fileName = `Ricevuta_${safeAutore}_${safeSettore}_${labelDate}.pdf`;
                      downloadDettaglioSpesaPdf({ spesa, fileName });
                    } catch (e) {
                      console.error("Errore generazione PDF Dettaglio Spesa:", e);
                    }
                  }}
                >
                  Scarica PDF
                </button>
              </div>
            ) : (
              <div className="button-group">
                <button className="btn" onClick={handleSave}>
                  Salva Modifiche
                </button>
                <button className="btn" onClick={() => setIsEditing(false)}>
                  Annulla
                </button>
              </div>
            )}
          </>
        )}
        
        {spesa.fotoUrl && (
          <div className="spesa-foto">
            <img src={spesa.fotoUrl} alt="foto spesa" />
          </div>
        )}
      </div>
    </div>
  );
}
